import { RFTfeature } from "../components/features/RFTfeature";

export const convertToRFT = (
  unitType = "",
  item,
  discount = "",
  fivePercent = ""
) => {
  let saleQty;
  let unit = "";
  let itemPrice;
  let totalPrice;
  let discountAmount;
  let itemDiscount;
  let companyCode = localStorage.getItem("companyCode");
  console.log('item', item);
  console.log('disccc', discount);

  if (RFTfeature()) {
    if (unitType == "serviceRFT") {
      if (item.fivePercent && fivePercent != "ignore") {
        saleQty = item.saleType == "pieces" ? item.pricePerPiece :item.saleQuantity
          ? parseFloat(item.saleType == "pieces" ? (item.pricePerPiece * 328 - item.fivePercent * 328):(item.saleQuantity * 328 - item.fivePercent * 328))
          : parseFloat(1 * 328 - item.fivePercent * 328);
        itemPrice = item.saleType == "pieces" ? item.pricePerPiece :item.salePrice
          ? parseFloat(item.saleType == "pieces" ? item.pricePerPiece:item.salePrice)
          : parseFloat(item.saleType == "pieces" ? item.pricePerPiece:item.price);
        totalPrice = Math.ceil(itemPrice * saleQty - discount);
      } else if (fivePercent == "saleItem") {
        saleQty = (item.saleType == "pieces" ? item.pricePerPiece:(item.saleQuantity ? parseFloat(item.saleQuantity) : 1));
        itemPrice =item.saleType == "pieces" ? item.pricePerPiece:item.salePrice
          ? parseFloat(item.saleType == "pieces" ? item.pricePerPiece:item.salePrice)
          : parseFloat(item.saleType == "pieces" ? item.pricePerPiece:item.price);
        totalPrice = Math.ceil(itemPrice * saleQty - discount);
      } else {
        saleQty = (item.saleType == "pieces" ?  parseFloat(item.pricePerPiece * 328) : (item.saleQuantity ? parseFloat(item.saleQuantity * 328) : 1));
        itemPrice = item.saleType == "pieces" ? item.pricePerPiece:item.salePrice
          ? parseFloat(item.saleType == "pieces" ? item.pricePerPiece:item.salePrice)
          : parseFloat(item.saleType == "pieces" ? item.pricePerPiece:item.price);
        totalPrice = Math.ceil(itemPrice * saleQty - discount);
      }
      unit = "RFT";
    } else if (unitType == "RFT") {
      unit = "RFT";
      if (fivePercent == "saleItem") {
        saleQty = item.saleQuantity ? Number(item.saleQuantity) : 1;
        itemPrice = item.saleType == "pieces" ? item.pricePerPiece:item.salePrice
          ? Number(item.saleType == "pieces" ? item.pricePerPiece:item.salePrice)
          : Number(item.saleType == "pieces" ? item.pricePerPiece:item.price);
        totalPrice = (itemPrice * saleQty - discount);
        console.log('ttoal', totalPrice)
      } else {
        saleQty = item.saleType == "pieces" ? item.pricePerPiece:item.saleQuantity
          ? Number((item.saleType == "pieces" ? item.pricePerPiece:item.saleQuantity) * 328)
          : 1 * 328;
        itemPrice = item.saleType == "pieces" ? item.pricePerPiece:item.salePrice
          ? Number(item.saleType == "pieces" ? item.pricePerPiece:item.salePrice)
          : Number(item.saleType == "pieces" ? item.pricePerPiece:item.price);
        totalPrice = Math.ceil(itemPrice * saleQty - discount);
        console.log('ttoaltwo', totalPrice)
      }
    } else {
      unit = item.unit;
      saleQty = item.saleType == "pieces" ? item.pricePerPiece:(item.saleQuantity ? Number(item.saleQuantity) : 1);
      itemPrice = (item.saleType == "pieces" ? item.pricePerPiece:item.salePrice)
        ? Number(item.saleType == "pieces" ? item.pricePerPiece:item.salePrice)
        : Number(item.saleType == "pieces" ? item.pricePerPiece:item.price);
      totalPrice =(itemPrice * saleQty - discount);
      console.log('ttoalthree', totalPrice)
    }
  } else {
    if (item.unit) {
      unit = item.unit;
    }
    saleQty = (item.saleQuantity ? Number(item.saleQuantity) : 1);
    itemPrice = (item.saleType == "pieces" ? item.pricePerPiece:item.salePrice)
      ? Number(item.saleType == "pieces" ? item.pricePerPiece:item.salePrice)
      : Number(item.saleType == "pieces" ? item.pricePerPiece:item.price);

    totalPrice = (itemPrice * saleQty - discount);
    console.log('ttoalthreeunit', totalPrice)
  }

  if (item.saleDiscount) {
    if (item.saleDiscount) {
      itemDiscount = item.saleDiscount;
      let eachValue = (item.saleDiscount / 100) * totalPrice;
      discountAmount = eachValue;
    } else {
      discountAmount = 0;
      itemDiscount = 0;
    }
  } else {
    if (item.discount) {
      itemDiscount = item.discount;
      let eachValue = (item.discount / 100) * totalPrice;
      discountAmount = eachValue;
    } else {
      discountAmount = 0;
      itemDiscount = 0;
    }
  }
  console.log('prdisc', discountAmount)
  console.log('prdisc', totalPrice)

  return {
    saleQty: saleQty,
    unit: unit,
    itemPrice: itemPrice,
    discountAmount:(discountAmount),
    itemDiscount: itemDiscount,
    totalPrice: totalPrice - (discountAmount),
  };
};
